import * as api from '../../services/website'

export const FETCH_ARTICLES= 'FETCH_ARTICLES';




export const fetchArticles = (params, pagination, sort, extra) => {

    return {
        type: FETCH_ARTICLES,
        payload: {
            promise: api.findArticles(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};



// WEBPACK FOOTER //
// ./src/redux/actions/website.js